import { render, staticRenderFns } from "./SchedulingList.vue?vue&type=template&id=63033b10&"
import script from "./SchedulingList.vue?vue&type=script&lang=ts&"
export * from "./SchedulingList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports